import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashPermanently: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrashPermanently"><Path d="M4.5 6L5.5 21.5H18.5L19.5 6" stroke="currentColor" strokeLinecap="square"/><Path d="M3 5.5H21" stroke="currentColor" strokeLinecap="square"/><Path d="M8.54834 5.4171C8.82587 3.76155 10.2656 2.5 12 2.5C13.7344 2.5 15.1742 3.76155 15.4517 5.4171" stroke="currentColor" strokeLinecap="square"/><Path d="M9 10.5L15 16.5M15 10.5L9 16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconTrashPermanently;
